import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/auth/authentication.service'
import { Trade1031Service } from '../../shared/providers/Trade1031.service'
import { UserManagerService } from '../../shared/providers/user-manager.service'
import { ValidationService } from '../../shared/providers/validation.service'
import { IExchangeCodeOutputModel } from '../../shared/models/ExchangeCodeOutputModel'
import { IExchangeInvitesList } from '../../shared/models/DashboardDataOModel';
import { Router } from '@angular/router';

@Component({
    selector: 'app-dashboard-1031-initial',
    templateUrl: './dashboard-1031-initial.component.html'
})
export class Dashboard1031InitialComponent implements OnInit {

    constructor(private Authentication: AuthenticationService, private _trade1031Service: Trade1031Service, public Validation: ValidationService, private _userManagerService: UserManagerService, private router: Router) {
        this.LoggedInUser = this.Authentication.user;
        if ((this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031) || this.Authentication.IsUserRole(this.Authentication.UserRole.Broker)) && this.LoggedInUser != null) {

            //if (this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031)) {
            //    this._userManagerService.getUserDetails(this.LoggedInUser.Guid).subscribe(response => {
            //        if (response.Is1031DashboardEnabled) {
            //            this.router.navigateByUrl('dashboard-1031');
            //        }
            //    });
            //}
        }
    }
    LoggedInUser: any;
    exchangeCodes: IExchangeCodeOutputModel[];
    ExchangeInvitesList: IExchangeInvitesList;

  ngOnInit() {
    ////alert();
        this.Authentication.isLoggedIn.subscribe(response => {
            if (response) {
                this.LoggedInUser = this.Authentication.user;
                if ((this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031) || this.Authentication.IsUserRole(this.Authentication.UserRole.Broker)) && this.LoggedInUser != null) {

                    this._trade1031Service.GetExchangeCode(this.LoggedInUser.Id).subscribe(res => {
                        this.exchangeCodes = res;
                        //this.exchangeCodes.forEach(item => {
                        //    let ProjectedSaleDate = this.Validation.convertUTCDateToLocalDate(item.ProjectedSaleDate);
                        //    item.ExchangeCode = item.ExchangeCode + "  " + this.Validation.formatDatetoMMDDYYYY(ProjectedSaleDate);
                        //    let SaleDateEnd = this.Validation.convertUTCDateToLocalDate(this.Validation.addDays(ProjectedSaleDate, 180));
                        //    item.ExchangeCode = item.ExchangeCode + " - " + this.Validation.formatDatetoMMDDYYYY(SaleDateEnd);
                        //});
                        let selectedExchange = this.exchangeCodes[0].Id;
                        this.ExchangeInvitesList = null;
                        this._trade1031Service.GetExchangeBrokers(selectedExchange).subscribe(res => {
                            if (res.length > 0) {
                                this.ExchangeInvitesList = res[0];
                            }
                        });
                    });
                }
            }
        });
    }
}

